export class TimelineStep {

    public url: string;
    public description: string;
    public status: TimelineStepStatus = TimelineStepStatus.PENDING;
    public isClickable: boolean;
}
export enum TimelineStepStatus {
    ACTIVE = 'ACTIVE', PENDING = 'PENDING', COMPLETE = 'COMPLETE'
}

